import { BodyMediumMidEmphasis } from "@/design-system";
import colors from "@/theme/colors";
import { Checkbox, ListItem, ListItemButton, ListItemIcon } from "@mui/material";
import { UncheckedCheckboxIcon } from './UncheckedCheckboxIcon';
import { css } from '@emotion/css';

export type OptionType = {
  value: string;
  description: string;
  amount: number;
  disabled?: boolean;
};

type Props = OptionType & {
  filterName: string;
  checked: boolean;
  handleToggle: (filterName: string, value: string, description: string) => () => void;
}

export const FilterOption: React.FC<Props> = ({
  filterName,
  value,
  description,
  amount,
  disabled,
  handleToggle,
  checked,
}) => {
  const inputId = `${filterName}-${value}`;

  const onClick = () => {
    if (disabled) return;
    handleToggle(filterName, value, description)();
  };

  return (
    <ListItem disablePadding component="div" onClick={onClick}>
      <ListItemButton
        data-testid="itemButton"
        className={styles.listItem}
        disabled={disabled && !checked}
        tabIndex={-1}
        role="none"
      >
        <ListItemIcon>
          <Checkbox
            className={styles.checklist}
            icon={<UncheckedCheckboxIcon />}
            edge="end"
            color="secondary"
            checked={checked}
            data-testid="itemCheckbox"
            disabled={disabled && !checked}
            id={inputId}
          />
        </ListItemIcon>
        <BodyMediumMidEmphasis
          data-testid="itemLabel"
          htmlFor={inputId}
        >
          {description}
        </BodyMediumMidEmphasis>
        <BodyMediumMidEmphasis color={colors.slate} className={styles.amount}>
          ({amount})
        </BodyMediumMidEmphasis>
      </ListItemButton>
    </ListItem>
  );
};

const styles = {
  listItem: css`
    &.MuiListItemButton-root {
      padding: 9px 0px;
    }
    & > .MuiListItemIcon-root {
      min-width: auto;
    }
  `,
  checklist: css`
    &.MuiCheckbox-root {
      color: ${colors.prussian};
      padding: 0px;
      margin-right: 8px;
    }
  `,
  amount: css`
    padding-left: 4px;
  `,
};
